export const LAZY_STYLES_ENABLED = !!(
  typeof window !== 'undefined' &&
  // eslint-disable-next-line @stripe-internal/stripe/no-window-preloaded-access, @typescript-eslint/no-explicit-any
  (window as any)?.PRELOADED?.flags?.enable_sail_engine_lazy_styles
);
